import {needAuth} from "../instance/Instance";

async function getProjectCodeListBySearch(search, pageable) {

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/projectcode?'+pageStr,search);
    }catch (error){
        return error;
    }
}

async function createProjectCode(customCode) {
    try{
        return  await needAuth.post('/projectcode/create', customCode);
    }catch (error){
        return error;
    }
}

async function updateProjectCode(customCode) {
    try{
        return  await needAuth.put('/projectcode', customCode);
    }catch (error){
        return error;
    }
}

async function deleteProjectCode(id) {
    try{
        return  await needAuth.delete('/projectcode/'+id);
    }catch (error){
        return error;
    }
}


async function getProjectCodeList() {

    return  await needAuth.get('/projectcode');

}


export {getProjectCodeListBySearch, getProjectCodeList, createProjectCode, updateProjectCode, deleteProjectCode};